import { TEXTOS } from '../../manual-textos';
import {
  blocoCapitulo,
  blocoSecao,
  blocoTexto,
} from '../blocos';
import type { Bloco } from '../blocos';
import type { ManualData } from '../../manual-types';

export function capitulo7(dados: ManualData): Bloco[] {
  const blocos: Bloco[] = [blocoCapitulo(7, 'Desativação, desmontagem e descarte')];
  blocos.push(...blocoTexto(TEXTOS.aberturaEncerramento, 'c7-abertura'));
  blocos.push(blocoSecao('7.1', 'Desativação'));
  blocos.push(...blocoTexto(dados.desativacao || TEXTOS.desativacao, 'c7-desativacao'));
  blocos.push(blocoSecao('7.2', 'Desmontagem'));
  blocos.push(...blocoTexto(dados.desmontagem || TEXTOS.desmontagem, 'c7-desmontagem'));
  blocos.push(blocoSecao('7.3', 'Descarte'));
  blocos.push(...blocoTexto(dados.descarte || TEXTOS.descarte, 'c7-descarte'));
  return blocos;
}
